import store from '@/store'
import { getLocal, getSession } from '../libs/utils'

export default function Initializer () {
  let lastCenter = getLocal('lastCenter', 'object') || null
  let userInfo = getSession('risUserInfo', 'object') || null
  if (userInfo && userInfo.id) {
    store.dispatch('setUserInfo', {userName: userInfo.real_name || userInfo.user_name, userId: userInfo.id})
  }
  if (userInfo && lastCenter && userInfo.id === lastCenter.userId) {
    if (lastCenter && lastCenter.name && lastCenter.id) {
      store.dispatch('setCurrentCenter', lastCenter)
    }
  }
}
